import React from 'react';
import PropTypes from 'prop-types';
import MuiTableBody from '@material-ui/core/TableBody';
import TableRow from './TableRow';
import TableBodyCell from './TableBodyCell';
import styled from 'src/ui/library/styled';
import TableActionBodyCell from './TableActionBodyCell';

const styles = theme => ({
  root: {},
  noData: {
    visibility: 'hidden',
  },
});

class TableBody extends React.Component {
  static propTypes = {
    /** Data that will be used to describe rows */
    rows: PropTypes.array.isRequired,
    /** Data that will be used to describe columns */
    columns: PropTypes.array.isRequired,
    /**
     * Read Only mode will force table to ignore renderComponent per columns and display cell value.
     * It will also make rows not selectable.
     */
    readOnly: PropTypes.bool.isRequired,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool.isRequired,
    /** Callback reference to the internal setState */
    setUpdateSelectCell: PropTypes.func.isRequired,
    /** Callback function for to handle row selection */
    onRowSelect: PropTypes.func.isRequired,
    /** Developer styles overrides */
    styleOverrides: PropTypes.object.isRequired,
    /** Styles to be applied to component */
    classes: PropTypes.object,
    showCheckbox: PropTypes.bool,
    notApplicable: PropTypes.bool,
    notSure: PropTypes.bool,
  };

  render() {
    const {
      classes,
      rows,
      setUpdateComponent,
      onRowClick,
      onCellClick,
      onViewDetail,
      setUpdateSelectCell,
      styleOverrides,
      onRowSelect,
      selectableRows,
      actionable,
      actionableRender,
      getMetaForMenu,
      columns,
      readOnly,
      tableRef,
      showCheckbox,
      notApplicable,
      notSure,
      onDelete,
      pageData,
      isTaskSubmitted,
    } = this.props;
    const totalColumns = columns.length;
    const totalRows = rows.length;

    if (!rows.length) {
      return (
        <MuiTableBody>
          <tr className={classes.noData}>
            <td colSpan={totalColumns} aria-label="No value"></td>
          </tr>
        </MuiTableBody>
      );
    }

    return (
      <MuiTableBody>
        {rows.map((row, rowIndex) => (
          <TableRow
            key={rowIndex}
            rowType={'body'}
            rowIndex={rowIndex}
            onClick={event => onRowClick({ rowIndex, origRowIndex: row[0].origRowIndex }, event)}>
            {(actionable || selectableRows) && !readOnly ? (
              <TableActionBodyCell
                tableRef={tableRef}
                rowIndex={rowIndex}
                rowData={row}
                getMetaForMenu={getMetaForMenu}
                actionable={actionable}
                actionableRender={actionableRender}
                selectableRows={selectableRows}
                setUpdateSelectCell={setUpdateSelectCell}
                onRowSelect={onRowSelect}
                onViewDetail={onViewDetail}
                isLastRow={rowIndex + 1 === totalRows}
                showCheckbox={showCheckbox}
                notApplicable={notApplicable}
                notSure={notSure}
                onDelete={onDelete}
                pageData={pageData}
                isTaskSubmitted={isTaskSubmitted}
              />
            ) : null}
            {row.map((col, colIndex) =>
              columns[colIndex].visible ? (
                <TableBodyCell
                  oddRow={rowIndex % 2 !== 0}
                  evenRow={rowIndex % 2 === 0}
                  lastRow={rowIndex + 1 === totalRows}
                  totalColumns={totalColumns}
                  colIndex={colIndex}
                  rowIndex={rowIndex}
                  rowData={row}
                  cellData={col}
                  onRowSelect={onRowSelect}
                  selectableRows={selectableRows}
                  columnData={columns[colIndex]}
                  styleOverrides={styleOverrides.TableBodyCell}
                  setUpdateComponent={setUpdateComponent}
                  key={colIndex}
                  onClick={onCellClick.bind(null, { rowIndex, colIndex, origRowIndex: col.origRowIndex })}
                />
              ) : null,
            )}
          </TableRow>
        ))}
      </MuiTableBody>
    );
  }
}

export default styled(TableBody)(styles);
